import * as React from "react";
import type { TypeTabsProps } from "./TabsTypes";
import TabsHybrid from "./TabsHybrid";

// TabsHybrid's default export is the stateful class that carries the
// Button/Panel statics; a forwarded ref resolves to that class instance
// (same as the original Tabs class — no consumer relies on a DOM ref here).
type TabsComponent = React.ForwardRefExoticComponent<
  React.PropsWithoutRef<TypeTabsProps> &
    React.RefAttributes<InstanceType<typeof TabsHybrid>>
> & {
  Button: typeof TabsHybrid.Button;
  Panel: typeof TabsHybrid.Panel;
};

/**
 * Tabs component. Automatically routes between the Tailwind implementation
 * (preferred) and the styled-components implementation (for consumers using
 * system props). Defined as a real wrapper (not a bare re-export) so
 * react-docgen can extract its props for the Racine props-docs build.
 */
const Tabs = React.forwardRef<InstanceType<typeof TabsHybrid>, TypeTabsProps>(
  (props, ref) => <TabsHybrid {...props} ref={ref} />
) as TabsComponent;

Tabs.displayName = "Tabs";
// Preserve the compound-component API consumed as <Tabs.Button> / <Tabs.Panel>.
Tabs.Button = TabsHybrid.Button;
Tabs.Panel = TabsHybrid.Panel;

export default Tabs;
